import icon from './assets/notification-logo.png';

export default function buildNotification(data) {
    const { cId, cmpId, cType, cUrl, eventId, message: body, ticketHash, title = 'NIKÉ', type } = data || {};

    const options = {
        icon,
        body,
        tag: 'notification' + (type ? ` ${type}` : ''),
        data: { url: '/' },
        vibrate: [200, 100, 200]
    };

    switch (type) {
        case 'BETBOOK_ANALYSIS':
            options.data.url = `/komunita/analyzy/${cUrl}`;
            break;
        case 'BETBOOK_TICKET':
            options.data.url = `/komunita/tikety/${cUrl}`;
            break;
        case 'ACCOUNT_DEPOSIT':
        case 'DEPOSIT':
        case 'ACCOUNT_DOC_VERIFIED':
        case 'DOC_VERIFIED':
            options.data.url = `${options.data.url}?utm_source=push&utm_campaing=ticker`;
            break;
        case 'MANUAL':
        case 'MARKETING':
            if (cUrl) {
                options.data.url = cUrl;
            } else {
                switch (String(cType)) {
                    // push notifikácia nebude odkazovať na špecifický obsah, po otvorení sa otvorí home page niké
                    case '0':
                        break;
                    // push notifikácia bude odkazovať na článok - pre korektné zobrazovanie na všetkých kanáloch musí byť tento definovaný v jazyku markdown
                    case '1':
                        options.data.url = `/clanky/${cId}`;
                        break;
                    // push notifikácia bude odkazovať na detail zápasu (podujatia)
                    case '2':
                        options.data.url = `/tipovanie/zapas/${cId}`;
                        break;
                    // push notifikácia bude odkazovať na analýzu zápasu (podujatia)
                    case '3':
                        options.data.url = `/analyzy/${cId}`;
                        break;
                    default:
                        break;
                }
                options.tag += ` ${cType} ${cId}`;
            }
            // pridame kampan kvoli GA
            options.data.url = `${options.data.url}?utm_source=push_manual&utm_campaign=${cmpId || ''}`;
            break;
        case 'MATCH_BEFORE_START_10_MIN':
        case 'MATCH_START':
        case 'MATCH_CARDS':
        case 'MATCH_PERIOD_START':
        case 'MATCH_PERIOD_PROLONGATION':
        case 'MATCH_SCORE':
        case 'MATCH_FINISH':
        case 'MATCH_INTERRUPTION':
        case 'MATCH_CANCEL':
            options.tag += ` ${eventId}`;
            options.data.url = `/tipovanie/zapas/${eventId}?utm_source=push&utm_campaing=ticker`;
            break;
        case 'PICK':
        case 'TICKET':
            options.tag += ` ${ticketHash}`;
            options.data.url = `/tiket/${ticketHash}?utm_source=push&utm_campaing=ticker`;
            break;
        default:
            break;
    }

    return { title, options };
}
